export default "__VITE_ASSET__BWA3DvwT__"